export default __webpack_public_path__ + "static/businnes_graph-fafa766a7590d7d1a0b26efa3a6b26b6.png";